import React from 'react';
import { withLocalize } from 'react-localize-redux';
import ExcelExportButton from '../common/excelExportButton';
import OldStyleSubsection from '../common/oldStyleSubsection';

class PublicContracts extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? null : this.renderContent(this.props.data));
    }

    renderContent(data) {
        return (
            <div>
                {data.map(summary => <OldStyleSubsection isBold
                        key={this.props.sectionId+`Items_${summary.id}`}
                        sectionId={this.props.sectionId}
                        subsectionId={this.props.sectionId+`Items_${summary.id}`}
                        subsectionName={this.props.translate(`Report.PublicContracts.SubsectionName.${summary.id}`)}
                        subsectionData={{ contractId: summary.id }}
                    />
                )}
                <ExcelExportButton link="public-contracts" entityId={this.props.id} report={this.props.reportType} />
            </div>
        );
    }
}

export default withLocalize(PublicContracts);